import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

// Component
import Comment from '../../../../modules/comments/components/modal-comments/comment';

// Styles
import styles from './comment-thread.module.css';

const CommentThread = ({
  articleId,
  comment,
  className,
  level,
  isLast,
  hideReactionsBlock = false
}) => (
  <div
    key={comment.id}
    className={clsx(styles.wrapper, className)}
  >
    <Comment
      hideReactionsBlock={hideReactionsBlock}
      comment={comment}
      level={level}
      articleId={articleId}
      isLast={comment.replies?.length === 0 && isLast}
    />
    {
      comment.replies?.length >= 1 ? (
        <div className={styles.threadNode}>
          {
            comment.replies.map((commentReply, index) => (
              <CommentThread
                hideReactionsBlock={hideReactionsBlock}
                key={commentReply.id}
                comment={commentReply}
                level={level + 1}
                articleId={articleId}
                isLast={index === comment.replies.length - 1 && isLast}
              />
            ))
          }
        </div>
      ) : null
    }
  </div>
);

CommentThread.propTypes = {
  className: PropTypes.string,
  comment: PropTypes.object.isRequired,
  level: PropTypes.number.isRequired,
  isLast: PropTypes.bool
};

CommentThread.defaultProps = {
  className: '',
  isLast: false
};

export default CommentThread;
